import { MembersAuditLog } from '@oxappsec/ox-unified-audit-logger';
import { FC } from 'react';
import AdditionalInfoItem from '../AdditionalInfoItem';

const MembersAdditionalInfo: FC<
  React.PropsWithChildren<MembersAdditionalInfoProps>
> = ({ auditLog }) => {
  return (
    <>
      <AdditionalInfoItem name='Member Email' data={auditLog.memberEmail} />
      {auditLog.memberRoles?.length ? (
        <AdditionalInfoItem
          name='Member Roles'
          data={auditLog.memberRoles.join(', ')}
        />
      ) : null}
    </>
  );
};

export interface MembersAdditionalInfoProps {
  auditLog: MembersAuditLog;
}

export default MembersAdditionalInfo;
